import { Button, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import classnames from 'classnames';

import ButtonRow from '../../../components/ButtonRow';
import { useDynamicFormContext } from '../context';
import { fields } from '../definitions';
import { DynamicFormState, FilledOutField, Requiredness } from '../types';

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    fontWeight: 'bold',
    color: theme.palette.primary.dark,
    paddingBottom: theme.spacing(1),
  },
  field: {
    paddingBottom: theme.spacing(2),
  },
  hidden: {
    display: 'none',
  },
}));

interface DynamicFormProps {
  state: DynamicFormState;
  filledOutFields: FilledOutField[];
  shownFieldIds: number[];
  onSubmit: () => void;
}

function DynamicForm(props: DynamicFormProps) {
  const classes = useStyles();

  const { formIsReadOnly } = useDynamicFormContext();

  const canSave = !formIsReadOnly;

  // filter out optional fields without answers after the form has been submitted
  const filledOutFields =
    props.state === 'open'
      ? props.filledOutFields
      : props.filledOutFields.filter(
          (filledOutField: FilledOutField) =>
            filledOutField.field.requiredness === Requiredness.REQUIRED ||
            (filledOutField.field.requiredness === Requiredness.OPTIONAL &&
              filledOutField.answer !== undefined),
        );

  return (
    <>
      {filledOutFields.map((filledOutField) => {
        const Field = fields[filledOutField.field.discr];

        const hidden = !props.shownFieldIds.includes(filledOutField.field.id);

        const isRequired =
          filledOutField.field.requiredness === Requiredness.REQUIRED;

        let title = filledOutField.field.title;
        if (!formIsReadOnly && isRequired) {
          title += ' *';
        }

        return (
          <div
            key={filledOutField.field.id}
            className={classnames(
              classes.field,
              hidden ? classes.hidden : undefined,
            )}
          >
            <div className={classes.title}>{title}</div>
            <Field
              state={props.state}
              filledOutField={filledOutField}
              hasServerError={false}
            />
          </div>
        );
      })}
      {canSave && (
        <ButtonRow>
          <Button
            size="large"
            variant="contained"
            color="primary"
            onClick={() => props.onSubmit()}
          >
            Opslaan
          </Button>
        </ButtonRow>
      )}
    </>
  );
}

export default DynamicForm;
